import React from 'react';
import { connect } from 'react-redux';

import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields } from 'apps/auth/components/form-multi/utils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { PROFILE_FORM_NAME } from 'apps/auth/constants/formName';

const ProfileFieldsEditModal = (props) => {
    const beforeSubmit = () => clearLeadingSpace(props.profilesFields, PROFILE_FORM_NAME, props.changeFormFieldValue);

    return props.profilesFields ? (
        <ModalComponent onCloseIconClick={props.onCloseIconClick}>
            <HeaderPanel title={props.headerTitle} subtitle={props.headerGrayTitle} />
            {props.profileForm && (
                <Form
                    id="profile_form_id"
                    formName={PROFILE_FORM_NAME}
                    getCanonicalPath={true}
                    fields={props.profilesFields}
                    beforeSubmit={beforeSubmit}
                    onSubmitHandler={(fields, json) => props.onSubmitHandler(fields, json)}
                >
                    {props.profileForm.editable && (
                        <>
                            {getSortFields(props.profilesFields).map((field) => {
                                if (field.name !== 'redirect') {
                                    return (
                                        <Row indent="adaptive-32-48" key={field.name}>
                                            <InputAutoDetect
                                                formName={PROFILE_FORM_NAME}
                                                field={field}
                                                defaultCountry={props.phoneCountry?.code}
                                                country={props.phoneCountry}
                                            />
                                        </Row>
                                    );
                                }
                            })}
                            <FixedBottomPanel>
                                <Button type="submit" raised={true} caption={props.buttonContinue} title={props.buttonContinue} />
                            </FixedBottomPanel>
                        </>
                    )}
                </Form>
            )}
        </ModalComponent>
    ) : null;
};

export default connect(null, { changeFormFieldValue })(ProfileFieldsEditModal);
